<template>
    <div class="focus-360__container">
        <iframe 
            frameborder="0" 
            class="focus-360__instance"
            ref="instance"
            :title="title"
            :src="source"
        ></iframe>
    </div>
</template>
<script>
import { WithBreakpointComponent } from './breakpoints';

export default {
    mixins: [WithBreakpointComponent],
    props: {
        source: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: false
        }
    }, 
    watch: {
        currentBreakpoint() {
            this.reload();
        }
    },
    methods: {
        reload() {
            this.$refs.instance.src = this.source;
        }
    }
};
</script>
